import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'

export const getDefaultReplacementContact = (entryIdItem: IFormProfile | DataModel): DataModel => {
  const entityHpRoles = entryIdItem.get('PR_HP_ROLE')
  const entityRegion = entryIdItem.get('Region')
  const entityMarket = entryIdItem.get('Market')
  const partnerId = entryIdItem.get('PartnerID')

  return new DataModel({
    PR_HP_ROLE: entityHpRoles,
    Region: entityRegion,
    Market: entityMarket,
    PartnerID: partnerId,
    ContactID: '',
  })
}
